import { render, staticRenderFns } from "./CarrierIncidentsTable.vue?vue&type=template&id=7382bb22&scoped=true&"
import script from "./CarrierIncidentsTable.vue?vue&type=script&lang=js&"
export * from "./CarrierIncidentsTable.vue?vue&type=script&lang=js&"
import style0 from "./CarrierIncidentsTable.vue?vue&type=style&index=0&id=7382bb22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7382bb22",
  null
  
)

export default component.exports